import tw, { css } from 'twin.macro'
import { graphql, useStaticQuery } from 'gatsby'
import { useLocale } from '@plugins/bw-i18next'
import HubspotForm from '@/components/ui/hubspot-form'

export default function Newsletter() {
  const { currentContentfulCode } = useLocale()
  const form = useStaticQuery(graphql`
    query Newsletter {
      allContentfulComponentHubSpotForm(filter: { contentful_id: { eq: "4MdgngvVzU8XuWAIVglBPP" } }) {
        nodes {
          ...HubSpotForm
        }
      }
    }
  `).allContentfulComponentHubSpotForm.nodes.find((node) => node.node_locale === currentContentfulCode)

  return (
    <div
      css={[
        css`
          ${tw`rounded-2xl px-6 py-3 bg-white dark:bg-gray-700 w-full flex gap-4 text-balance`}
          .bw-hubspot-form-loader {
            ${tw`flex p-4! w-auto flex-[1 1 50%] justify-end`}
            svg {
              ${tw`w-8 h-8`}
            }
          }
          .bw-hubspot-form {
            ${tw`flex flex-col gap-4 w-full min-h-0 items-center`}
            ${tw`lg:flex-row`}
          }
          .bw-hubspot-form-copy * {
            ${tw`inline-block text-lg mb-0`}
          }
          .bw-hubspot-form-headline {
            ${tw`font-bold mr-2`}
          }
          .bw-hs-form-container {
            ${tw`w-full sm:w-auto md:flex-[1 0 auto] lg:self-end`}
          }
          .hs-form .hs-input:not([type='radio']):not([type='checkbox']) {
            ${tw`h-12`}
          }
          form {
            ${tw`flex w-auto items-start justify-center md:justify-end`}
            h2, .hs-field-desc {
              ${tw`hidden!`}
            }
            .hs-input {
              ${tw`rounded-full! pl-5!`}
            }
          }
          .hs-form-field {
            ${tw`relative flex-1 w-[400px] mb-0 md:flex-[0 1 auto]`}

            > label {
              ${tw`absolute top-[0.625rem] left-5 px-1 text-gray-400 transition-[color transform] transform origin-left`}
              ${tw`bg-white dark:bg-gray-700`}
              .hs-form-required {
                ${tw`hidden`}
              }
            }
            .input input {
              ${tw`placeholder:text-transparent! dark:bg-gray-700!`}
            }
          }
          .hs-form-field:has(input:focus) > label,
          .hs-form-field:has(input:not(:placeholder-shown)) > label {
            ${tw`translate-y-[-1.4rem] scale-75! text-indigoBlue dark:text-white`}
          }

          input.hs-button {
            ${tw`h-12 my-0 ml-2 text-lg! leading-5! bg-white border-primaryBlue border-2 border-solid text-primaryBlue`}
            ${tw`dark:(border-white text-gray-800)`}
            ${tw`hover:(bg-primaryBlue! text-white!)`}
            ${tw`dark:hover:(bg-gray-700!)`}
          }
          .hs-error-msgs {
            ${tw`list-none w-full pt-2 pl-4 md:mt-0 whitespace-pre`}
          }
          .submitted-message {
            ${tw`text-lg text-right font-bold`}
          }
        `,
      ]}
    >
      <HubspotForm id="newsletter" {...form} />
    </div>
  )
}
